document.addEventListener("variant:change",function(event){var variant=event.detail.variant,affirmdiv=document.querySelector(".affirm-as-low-as");affirmdiv.setAttribute("data-amount",variant.price),affirm.ui.refresh()});
//# sourceMappingURL=/s/files/1/1825/9663/t/19/assets/custom.js.map?v=1680726098
